import pick from 'lodash/pick';
import { Order } from '@types';

export const getOrderTbd = (order?: Order) => {
    if (!order?.tbd_reason) return;

    return pick(order, ['tbd_reason', 'tbd_reason_message']);
};

// todo cart.selectors, order-page.selectors, invoice.selectors
export const getOrderLineItemsTbd = () => {};

export const mergeTbd = () => {};
